import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import App from './App'
import CheckAuth from './CheckAuth'


const Root = ({ store }) => (
  <Provider store={store}>
	<CheckAuth />
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
}
export default Root